import { can, type AuthorizedUser } from '@dma/auth';
import { AuthorizationError, ApplicationError, type Logger } from '@dma/shared';
import { InvalidScientificEntryError } from '../../domain/errors/InvalidScientificEntryError';
import type { ScientificEntryRepository } from '../../domain/repositories/ScientificEntryRepository.interface';
import type { ScientificEntryCategory } from '../../domain/entities/ScientificEntry.entity';
import type { ScientificEntryDto } from '../dto/ScientificEntryDto';

export class GetAdminScientificEntriesUseCase {
  constructor(
    private readonly repository: ScientificEntryRepository,
    private readonly logger: Logger
  ) {}

  public async execute(actingUser: AuthorizedUser | null, category: ScientificEntryCategory): Promise<ScientificEntryDto[]> {
    if (!can(actingUser, 'scientific-entry:manage')) {
      throw new AuthorizationError();
    }

    try {
      const entries = await this.repository.getAllForAdmin(category);
      return entries.map((entry) => entry.props);
    } catch (error) {
      if (error instanceof InvalidScientificEntryError) {
        this.logger.error('Scientific entry content failed domain validation', {
          category,
          code: error.code,
          message: error.message
        });
        throw new ApplicationError('SCIENTIFIC_ENTRIES_UNAVAILABLE', 'فهرست مطالب در حال حاضر در دسترس نیست.', {
          cause: error
        });
      }
      throw error;
    }
  }
}
